export default {
  tab: {
    thisWeek: 'THIS WEEk',
    yesterday: 'YESTERDAY',
    toDay: 'TODAY',
    favorite: 'FAVORITE',
  },
  listTitleTable: {
    TICKER: 'TICKER',
    NEWS_TITLE: 'NEWS',
    NEWS_SOURCE: 'SOURCE',
    PUBLIC_DATE: 'TIME', // hh:mm
    FAVORITE: 'FAVORITE',
  },

  readMore: 'Read More',
  share: 'Share',
};
